import React, {useEffect} from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  FormHelperText,
} from '@material-ui/core'
export default function WMemoField({data, onChange}) {
  useEffect(() => {
    if (data?.default_value && data?.value === undefined) {
      let e = {
        target: {
          value: data.default_value,
        },
      }
      onChange(e, 'value', data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <InputLabel id="demo-mutiple-name-label">{data.name}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={data.name}
          value={data?.value || data?.default_value || []}
          onChange={e => {
            onChange(e, 'value', data)
          }}
          multiple
        >
          {data?.description?.map(f => {
            return <MenuItem value={f}>{f}</MenuItem>
          })}
        </Select>
        <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
      </FormControl>
    </Grid>
  )
}
